export default {
    getAllExperts (state) {
        return state.experts
    },
    getExpert (state) {
        return state.expert
    },
    getExpertVideos (state) {
        return state.expertVideos
    },
    getVideosFlag (state) {
        return state.videosComingSoonFlag
    },
    getExpertPlaylist (state) {
        return state.expertPlaylist
    },
    getExpertArchiveClips (state) {
        return state.expertArchiveClips
    },
    getExpertNextEvent (state) {
        return state.expertNextEvent
    }
}



// WEBPACK FOOTER //
// ./src/store/experts/getters.js